import React from 'react';
import { RoundInputNumber } from '../../app/components';
import './styles.css';

const PriceFilter = ({ bedrooms, onIncreaseBedrooms, onDecreaseBedrooms }) => (
  <div className="bedrooms-filter">
    <h2>Svefnherbergi</h2>
    <div>
      <RoundInputNumber
        value={bedrooms}
        onIncrease={onIncreaseBedrooms}
        onDecrease={onDecreaseBedrooms}
        inputColor="#222222"
        inputBackgroundColor="#00e39a"
        buttonsColor="#606060"
        buttonsBackgroundColor="#ffffff"
      />
    </div>
  </div>
);

PriceFilter.propTypes = {
  bedrooms: React.PropTypes.number.isRequired,
  onIncreaseBedrooms: React.PropTypes.func.isRequired,
  onDecreaseBedrooms: React.PropTypes.func.isRequired,
};

export default PriceFilter;



// WEBPACK FOOTER //
// ./src/browser/filters/BedroomsFilter/BedroomsFilter.js